import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useKiosks from 'app/hooks/useKiosks';
import DataGrid from'app/components/DataGrid';
import KioskModal from './KioskModal';
//import classes from './classes.module.scss';

import {
  formatKioskPrintModeCellValue,
  formatCheckoutTypeCellValue,
  formatKioskThemeCellValue,
  formatKioskLoginTypeCellValue,
  formatJobConfigCellValue,
  formatJobCellValue
} from 'app/utils/valueFormatters';

import {
  loginTypeOptions,
  themeOptions,
  checkoutTypeOptions,
  printModeOptions,
  formatOptions
} from 'app/utils/options';

import {
  me
} from 'shared/actions/userActions';

import {
  getJobConfigs
} from 'app/services/jobConfigs';

import {
  getSimpleJobs
} from 'app/services/jobs';

const Kiosks = () => {
  // if a kiosk is updated then refresh the session.
  // toggling catalog_screen on any kiosk should enable the Catalogs page
  const dispatch = useDispatch();
  const onUpdate = () => dispatch(me());

  // load needed resources on first render
  const [jobConfigs, setJobConfigs] = useState([]);
  const jobConfigOptions = formatOptions(jobConfigs);

  const [jobs, setJobs] = useState([]);

  const setup = async () => {
    let { records } = await getJobConfigs({ page: 1, per_page: 100 });
    setJobConfigs(records);

    let jobRecs = await getSimpleJobs();
    setJobs(jobRecs);
  }

  const getJobOptions = async (page = 1, perPage = 100, filter = null) => {
    let jobs = await getSimpleJobs();
    return formatOptions(jobs);
  }

  useEffect(() => {
    setup()
  }, []);

  const {
    resource,
    formIsOpen,
    currentRecord,
    onFormClose,
    onAdd,
    onEdit,
    onQuickAdd,
    onQuickEdit,
    onDataGridLoad,
    onFormSubmit,
    onDestroy,
    showFilters,
    getRowData
  } = useKiosks({
    onUpdate
  });

  const header = 'Kiosk';
  const addButtonLabel = 'Add Kiosk';

  const columnOrder = [
    'name',
    'header',
    'job',
    'job_config',
    'url',
    //'theme',
    'checkout_type',
    'login_type',
    'print_mode'
  ];

  const onlyColumns = [
    'id',
    'created_at',
    'updated_at',
    'job_config',
    'account_id',
    'url',
    'name',
    'header',
    'card_disabled',
    'haggle_mode',
    'print_mode',
    'kiosk_type',
    'login_type',
    'job',
    'job_id',
    'checkout_type',
    'msi_product_id',
    'msi_upgrade_code',
    'create_customer',
    'catalog_screen',
    'gallery_screen',
    'cart_screen',
    'start_screen',
    'catalog_button_type',
    'show_dates',
    'stripe_enabled',
    'tilby_enabled',
    'offsite_pos_enabled',
    'offsite_pos_type',
    //'theme',
    'logo_type',
    'logo_mime_type',
    'receipt_screen_type',
    'hide_order_details',
    'uppercase_labels',
    'timeout',
    'retention',
    'stripe_reader_label',
    'stripe_reader_location_id',
    'stripe_reader_code',
    'stripe_reader_enabled',
    'hide_buy_more',
    'set_mandatory_email',
    'tax_rate'
  ];

  const visibleColumns = [
    'name',
    'header',
    'job',
    'job_config',
    'url',
    //'theme',
    'checkout_type',
    'login_type',
    'print_mode'
  ]

  const columnDefOverrides = [
    {
      field: 'name',
      quickEdit: true
    },
    {
      field: 'header',
      quickEdit: true
    },
    {
      field: 'url',
      headerName: 'URL',
      width: '480px'
    },
    {
      field: 'job',
      headerName: 'Job',
      valueFormatter: value => formatJobCellValue(value),
      inputType: 'autocomplete',
      getInputOptions: getJobOptions,
      quickEdit: true
    },
    {
      field: 'theme',
      headerName: 'Theme',
      valueFormatter: value => formatKioskThemeCellValue(value),
      inputType: 'select',
      inputOptions: themeOptions,
      quickEdit: true
    },
    {
      field: 'checkout_type',
      headerName: 'Checkout Type',
      renderValues: data => [formatCheckoutTypeCellValue(data.checkout_type)],
      inputType: 'select',
      inputOptions: checkoutTypeOptions,
      quickEdit: true
    },
    {
      field: 'print_mode',
      headerName: 'Print Mode',
      renderValues: data => [formatKioskPrintModeCellValue(data.print_mode)],
      inputType: 'select',
      inputOptions: printModeOptions,
      quickEdit: true
    },
    {
      field: 'login_type',
      headerName: 'Login Type',
      renderValues: data => [formatKioskLoginTypeCellValue(data.login_type)],
      inputType: 'select',
      inputOptions: loginTypeOptions,
      quickEdit: true
    },
    {
      field: 'job_config',
      headerName: 'Product',
      valueFormatter: value => formatJobConfigCellValue(value),
      inputType: 'select',
      inputOptions: jobConfigOptions,
      quickEdit: true
    },
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        showQuickEdit={true}
        onQuickAdd={onQuickAdd}
        onQuickEdit={onQuickEdit}
        columnOrder={columnOrder}
        columnDefOverrides={columnDefOverrides}
        onlyColumns={onlyColumns}
        visibleColumns={visibleColumns}
        showFilters={showFilters}
        showSelect={false}
        loadingMessage="Loading kiosks..."
        onDataGridLoad={onDataGridLoad}
      />
      <KioskModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        kiosk={currentRecord}
        onFormSubmit={onFormSubmit}
        onDestroy={onDestroy}
        jobConfigs={jobConfigs}
        jobs={jobs}
      />
    </div>
  )
}

export default Kiosks;
